let fixed = (num, n) => {
  let m = parseFloat(num)
  return m.toFixed(n)
}

let toPercentage = (value) => {
  let str = Number(value * 100).toFixed(2)
  str += '%'
  return str
}

let dateFormat = (value) => {
  let date = new Date(value)
  let Y = date.getFullYear() + '年'
  let M = (date.getMonth() + 1) + '月'
  let df = Y + M
  return df
}

export default {
  fixed,
  toPercentage,
  dateFormat
}



// WEBPACK FOOTER //
// ./src/filters/index.js